module.exports = __webpack_public_path__ + "assets/img/boil_water.77051fcd.png";